<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'
  import Vol02 from './Vol02.vue'
  import Vol03 from './Vol03.vue'
  import Vol04 from './Vol04.vue'
  import Vol05 from './Vol05.vue'
  import Vol06 from './Vol06.vue'
  import Jewel03 from './Jewel03.vue'
  import Jewel05 from './Jewel05.vue'
  import Jewel06 from './Jewel06.vue'
  import PriTama01 from './PriTama01.vue'
  import PriTama02 from './PriTama02.vue'
  import PriTama03 from './PriTama03.vue'
  import PriTama04 from './PriTama04.vue'
  import Promo2018 from './Promo2018.vue'

  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */

  /** @type {ItemInfo[]} */ const itemsVol02 = Vol02.data().items
  /** @type {ItemInfo[]} */ const itemsVol03 = Vol03.data().items
  /** @type {ItemInfo[]} */ const itemsVol04 = Vol04.data().items
  /** @type {ItemInfo[]} */ const itemsVol05 = Vol05.data().items
  /** @type {ItemInfo[]} */ const itemsVol06 = Vol06.data().items
  /** @type {ItemInfo[]} */ const itemsJewel03 = Jewel03.data().items
  /** @type {ItemInfo[]} */ const itemsJewel05 = Jewel05.data().items
  /** @type {ItemInfo[]} */ const itemsJewel06 = Jewel06.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama01 = PriTama01.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama02 = PriTama02.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama03 = PriTama03.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama04 = PriTama04.data().items
  /** @type {ItemInfo[]} */ const itemsPromo2018 = Promo2018.data().items


  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-05-15',
        major: [
          'PT04',
          'PT05',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] WR
          // ================================================================================

          item({
            collection  : 'PT05',
            id          : 'PT5-89',
            rare        : 'WR',
            name        : 'ワンダーサーカスイブトップス',
            imgUrl      : '/images/items/PT5-89.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'FT|MM',
            type        : 'NT|SE',
            point       : 1100,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-90',
            rare        : 'WR',
            name        : 'ワンダーサーカスイブパンツ',
            imgUrl      : '/images/items/PT5-90.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'FT|MM',
            type        : 'NT|SE',
            point       : 1050,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-91',
            rare        : 'WR',
            name        : 'ワンダーサーカスイブシューズ',
            imgUrl      : '/images/items/PT5-91.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'FT|MM',
            type        : 'NT|SE',
            point       : 1000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-92',
            rare        : 'WR',
            name        : 'ワンダーサーカスイブヘアアクセ',
            imgUrl      : '/images/items/PT5-92.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'FT|MM',
            type        : 'NT|SE',
            point       : 1000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-93',
            rare        : 'WR',
            name        : 'ミッドナイトジュエリーアリストップス',
            imgUrl      : '/images/items/PT5-93.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'MM|FT',
            type        : 'SE|NT',
            point       : 1100,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-94',
            rare        : 'WR',
            name        : 'ミッドナイトジュエリーアリススカート',
            imgUrl      : '/images/items/PT5-94.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'MM|FT',
            type        : 'SE|NT',
            point       : 1050,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-95',
            rare        : 'WR',
            name        : 'ミッドナイトジュエリーアリスシューズ',
            imgUrl      : '/images/items/PT5-95.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'MM|FT',
            type        : 'SE|NT',
            point       : 1000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-96',
            rare        : 'WR',
            name        : 'ミッドナイトジュエリーアリスヘアアクセ',
            imgUrl      : '/images/items/PT5-96.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'MM|FT',
            type        : 'SE|NT',
            point       : 1000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ER
          // ================================================================================

          item({
            collection  : 'PT05',
            id          : 'ER5-01',
            rare        : 'ER',
            name        : 'クラシックロマンスビートワンピ',
            imgUrl      : '/images/items/ER5-01.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'ER5-02',
            rare        : 'ER',
            name        : 'クラシックロマンスビートシューズ',
            imgUrl      : '/images/items/ER5-02.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'ER5-03',
            rare        : 'ER',
            name        : 'クラシックロマンスビートヘアアクセ',
            imgUrl      : '/images/items/ER5-03.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            rare        : 'ER',
          }),


          item({
            collection  : 'PT05',
            id          : 'ER5-04',
            rare        : 'ER',
            name        : 'クラシックユニバースクイーンワンピ',
            imgUrl      : '/images/items/ER5-04.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'ER5-05',
            rare        : 'ER',
            name        : 'クラシックユニバースクイーンシューズ',
            imgUrl      : '/images/items/ER5-05.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'ER5-06',
            rare        : 'ER',
            name        : 'クラシックユニバースクイーンヘアアクセ',
            imgUrl      : '/images/items/ER5-06.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            rare        : 'ER',
          }),


          item({
            collection  : 'PT05',
            id          : 'ER5-07',
            rare        : 'ER',
            name        : 'キラッとチェックはあと♡パールワンピ',
            imgUrl      : '/images/items/ER5-07.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'ER5-08',
            rare        : 'ER',
            name        : 'キラッとチェックはあと♡パールシューズ',
            imgUrl      : '/images/items/ER5-08.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'ER5-09',
            rare        : 'ER',
            name        : 'キラッとチェックはあと♡パールヘアアクセ',
            imgUrl      : '/images/items/ER5-09.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            rare        : 'ER',
          }),


          item({
            collection  : 'PT05',
            id          : 'ER5-10',
            rare        : 'ER',
            name        : 'キラッとチェックダンスパンサーワンピ',
            imgUrl      : '/images/items/ER5-10.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'ER5-11',
            rare        : 'ER',
            name        : 'キラッとチェックダンスパンサーシューズ',
            imgUrl      : '/images/items/ER5-11.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DS',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'ER5-12',
            rare        : 'ER',
            name        : 'キラッとチェックダンスパンサーヘアアクセ',
            imgUrl      : '/images/items/ER5-12.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'DS',
            type        : 'CO',
            point       : 950,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            rare        : 'ER',
          }),


          // [NOTE] IR
          // ================================================================================

          item({
            collection  : 'PT05',
            id          : 'IR05-01',
            rare        : 'IR',
            name        : 'ムーンライトマジックイルミナージュドレス',
            imgUrl      : '/images/items/IR05-01.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'MM',
            type        : 'SE',
            point       : 1600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'IR05-02',
            rare        : 'IR',
            name        : 'ムーンライトマジックイルミナージュシューズ',
            imgUrl      : '/images/items/IR05-02.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'MM',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'IR05-03',
            rare        : 'IR',
            name        : 'ムーンライトマジックイルミナージュヘアアクセ',
            imgUrl      : '/images/items/IR05-03.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'MM',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            rare        : 'IR',
          }),


          item({
            collection  : 'PT05',
            id          : 'IR05-04',
            rare        : 'IR',
            name        : 'ムーンライトマジックイルミナージュパープルドレス',
            imgUrl      : '/images/items/IR05-04.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'MM',
            type        : 'SE',
            point       : 1600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'IR05-05',
            rare        : 'IR',
            name        : 'ムーンライトマジックイルミナージュパープルシューズ',
            imgUrl      : '/images/items/IR05-05.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'MM',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'IR05-06',
            rare        : 'IR',
            name        : 'ムーンライトマジックイルミナージュパープルヘアアクセ',
            imgUrl      : '/images/items/IR05-06.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'MM',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            rare        : 'IR',
          }),


          item({
            collection  : 'PT05',
            id          : 'IR05-07',
            rare        : 'IR',
            name        : 'ムーンライトマジックイルミナージュローズドレス',
            imgUrl      : '/images/items/IR05-07.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'MM',
            type        : 'SE',
            point       : 1600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'IR05-08',
            rare        : 'IR',
            name        : 'ムーンライトマジックイルミナージュローズシューズ',
            imgUrl      : '/images/items/IR05-08.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'MM',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'IR05-09',
            rare        : 'IR',
            name        : 'ムーンライトマジックイルミナージュローズヘアアクセ',
            imgUrl      : '/images/items/IR05-09.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'MM',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            rare        : 'IR',
          }),

          externalItem(itemsPriTama04, 'IR04-10'),
          externalItem(itemsPriTama04, 'IR04-11'),
          externalItem(itemsPriTama04, 'IR04-12'),
          item({
            collection  : 'PT04',
            rare        : 'IR',
          }),

          externalItem(itemsPriTama04, 'IR04-13'),
          externalItem(itemsPriTama04, 'IR04-14'),
          externalItem(itemsPriTama04, 'IR04-15'),
          item({
            collection  : 'PT04',
            rare        : 'IR',
          }),

          externalItem(itemsPriTama04, 'IR04-16'),
          externalItem(itemsPriTama04, 'IR04-17'),
          externalItem(itemsPriTama04, 'IR04-18'),
          item({
            collection  : 'PT04',
            rare        : 'IR',
          }),


          // [NOTE] FR
          // ================================================================================

          item({
            collection  : 'PT05',
            id          : 'PT5-01',
            rare        : 'FR',
            name        : 'プリ☆ファンまおうトップス',
            imgUrl      : '/images/items/PT5-01.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 1100,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-02',
            rare        : 'FR',
            name        : 'プリ☆ファンまおうスカート',
            imgUrl      : '/images/items/PT5-02.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 1050,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-03',
            rare        : 'FR',
            name        : 'プリ☆ファンまおうシューズ',
            imgUrl      : '/images/items/PT5-03.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-04',
            rare        : 'FR',
            name        : 'プリ☆ファンまおうヘアアクセ',
            imgUrl      : '/images/items/PT5-04.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-05',
            rare        : 'FR',
            name        : 'プリ☆ファンにんじゃトップス',
            imgUrl      : '/images/items/PT5-05.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'FT',
            type        : 'NT',
            point       : 1100,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-06',
            rare        : 'FR',
            name        : 'プリ☆ファンにんじゃスカート',
            imgUrl      : '/images/items/PT5-06.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'FT',
            type        : 'NT',
            point       : 1050,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-07',
            rare        : 'FR',
            name        : 'プリ☆ファンにんじゃシューズ',
            imgUrl      : '/images/items/PT5-07.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'FT',
            type        : 'NT',
            point       : 950,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-08',
            rare        : 'FR',
            name        : 'プリ☆ファンにんじゃヘアアクセ',
            imgUrl      : '/images/items/PT5-08.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'FT',
            type        : 'NT',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'PT05',
            id          : 'PT5-09',
            rare        : 'PR',
            name        : 'ミッドナイトジュエリートップス',
            imgUrl      : '/images/items/PT5-09.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'MM',
            type        : 'SE',
            point       : 900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-10',
            rare        : 'PR',
            name        : 'ミッドナイトジュエリースカート',
            imgUrl      : '/images/items/PT5-10.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'MM',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-11',
            rare        : 'PR',
            name        : 'ミッドナイトジュエリーシューズ',
            imgUrl      : '/images/items/PT5-11.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'MM',
            type        : 'SE',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-12',
            rare        : 'PR',
            name        : 'ミッドナイトジュエリーヘアアクセ',
            imgUrl      : '/images/items/PT5-12.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'MM',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-13',
            rare        : 'PR',
            name        : 'マスコットルルナトップス',
            imgUrl      : '/images/items/PT5-13.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-14',
            rare        : 'PR',
            name        : 'マスコットルルナスカート',
            imgUrl      : '/images/items/PT5-14.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-15',
            rare        : 'PR',
            name        : 'マスコットルルナシューズ',
            imgUrl      : '/images/items/PT5-15.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 850,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-16',
            rare        : 'PR',
            name        : 'マスコットルルナヘアアクセ',
            imgUrl      : '/images/items/PT5-16.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'LP',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-17',
            rare        : 'PR',
            name        : 'テディベアラブリートップス',
            imgUrl      : '/images/items/PT5-17.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-18',
            rare        : 'PR',
            name        : 'テディベアラブリースカート',
            imgUrl      : '/images/items/PT5-18.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-19',
            rare        : 'PR',
            name        : 'テディベアラブリーシューズ',
            imgUrl      : '/images/items/PT5-19.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-20',
            rare        : 'PR',
            name        : 'テディベアラブリーヘアアクセ',
            imgUrl      : '/images/items/PT5-20.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-21',
            rare        : 'PR',
            name        : 'テディベアポップトップス',
            imgUrl      : '/images/items/PT5-21.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 850,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-22',
            rare        : 'PR',
            name        : 'テディベアポップパンツ',
            imgUrl      : '/images/items/PT5-22.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-23',
            rare        : 'PR',
            name        : 'テディベアポップシューズ',
            imgUrl      : '/images/items/PT5-23.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-24',
            rare        : 'PR',
            name        : 'テディベアポップヘアアクセ',
            imgUrl      : '/images/items/PT5-24.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'PT05',
            id          : 'PT5-25',
            rare        : 'SR',
            name        : 'ポルカフローラワンピ',
            imgUrl      : '/images/items/PT5-25.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : 'FT',
            type        : 'NT',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-26',
            rare        : 'SR',
            name        : 'ポルカフローラシューズ',
            imgUrl      : '/images/items/PT5-26.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'FT',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-27',
            rare        : 'SR',
            name        : 'ポルカフローラヘアアクセ',
            imgUrl      : '/images/items/PT5-27.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'FT',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            rare        : 'SR',
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-28',
            rare        : 'SR',
            name        : 'レディールージュトップス',
            imgUrl      : '/images/items/PT5-28.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'MM',
            type        : 'SE',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-29',
            rare        : 'SR',
            name        : 'レディールージュスカート',
            imgUrl      : '/images/items/PT5-29.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'MM',
            type        : 'SE',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-30',
            rare        : 'SR',
            name        : 'レディールージュシューズ',
            imgUrl      : '/images/items/PT5-30.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'MM',
            type        : 'SE',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-31',
            rare        : 'SR',
            name        : 'レディールージュヘアアクセ',
            imgUrl      : '/images/items/PT5-31.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'MM',
            type        : 'SE',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-32',
            rare        : 'SR',
            name        : 'ビビッドマーチングピンクトップス',
            imgUrl      : '/images/items/PT5-32.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-33',
            rare        : 'SR',
            name        : 'ビビッドマーチングピンクスカート',
            imgUrl      : '/images/items/PT5-33.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-34',
            rare        : 'SR',
            name        : 'ビビッドマーチングピンクシューズ',
            imgUrl      : '/images/items/PT5-34.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-35',
            rare        : 'SR',
            name        : 'ビビッドマーチングピンクヘアアクセ',
            imgUrl      : '/images/items/PT5-35.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-36',
            rare        : 'SR',
            name        : 'フラワープリンセスパープルトップス',
            imgUrl      : '/images/items/PT5-36.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-37',
            rare        : 'SR',
            name        : 'フラワープリンセスパープルスカート',
            imgUrl      : '/images/items/PT5-37.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-38',
            rare        : 'SR',
            name        : 'フラワープリンセスパープルシューズ',
            imgUrl      : '/images/items/PT5-38.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-39',
            rare        : 'SR',
            name        : 'フラワープリンセスパープルヘアアクセ',
            imgUrl      : '/images/items/PT5-39.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-40',
            rare        : 'SR',
            name        : 'アイドルキャストセレブトップス',
            imgUrl      : '/images/items/PT5-40.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-41',
            rare        : 'SR',
            name        : 'アイドルキャストセレブスカート',
            imgUrl      : '/images/items/PT5-41.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-42',
            rare        : 'SR',
            name        : 'アイドルキャストセレブシューズ',
            imgUrl      : '/images/items/PT5-42.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-43',
            rare        : 'SR',
            name        : 'アイドルキャストセレブヘアアクセ',
            imgUrl      : '/images/items/PT5-43.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          // [NOTE] SR モーリーファンタジー限定
          // ================================================================================

          item({
            collection  : 'Molly',
            id          : 'MF-67',
            rare        : 'SR',
            name        : 'テディベアラブリーイエロートップス',
            imgUrl      : '/images/items/MF-67.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Molly',
            id          : 'MF-68',
            rare        : 'SR',
            name        : 'テディベアラブリーイエロースカート',
            imgUrl      : '/images/items/MF-68.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Molly',
            id          : 'MF-69',
            rare        : 'SR',
            name        : 'テディベアラブリーイエローシューズ',
            imgUrl      : '/images/items/MF-69.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Molly',
            id          : 'MF-70',
            rare        : 'SR',
            name        : 'テディベアラブリーイエローヘアアクセ',
            imgUrl      : '/images/items/MF-70.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'PT05',
            id          : 'PT5-45',
            rare        : 'R',
            name        : 'アテンションプリーズトップス',
            imgUrl      : '/images/items/PT5-45.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'MM',
            type        : 'SE',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-46',
            rare        : 'R',
            name        : 'アテンションプリーズスカート',
            imgUrl      : '/images/items/PT5-46.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'MM',
            type        : 'SE',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-47',
            rare        : 'R',
            name        : 'アテンションプリーズシューズ',
            imgUrl      : '/images/items/PT5-47.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'MM',
            type        : 'SE',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-48',
            rare        : 'R',
            name        : 'アテンションプリーズヘアアクセ',
            imgUrl      : '/images/items/PT5-48.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'MM',
            type        : 'SE',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-49',
            rare        : 'R',
            name        : 'スイートレトロワンピ',
            imgUrl      : '/images/items/PT5-49.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-50',
            rare        : 'R',
            name        : 'スイートレトロシューズ',
            imgUrl      : '/images/items/PT5-50.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-51',
            rare        : 'R',
            name        : 'スイートレトロヘアアクセ',
            imgUrl      : '/images/items/PT5-51.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            rare        : 'R',
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-52',
            rare        : 'R',
            name        : 'アクティブステップディアクラウンニット',
            imgUrl      : '/images/items/PT5-52.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'DC',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-53',
            rare        : 'R',
            name        : 'アクティブステップスカート',
            imgUrl      : '/images/items/PT5-53.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'DC',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-54',
            rare        : 'R',
            name        : 'アクティブステップシューズ',
            imgUrl      : '/images/items/PT5-54.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DC',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-55',
            rare        : 'R',
            name        : 'アクティブステップヘアアクセ',
            imgUrl      : '/images/items/PT5-55.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'DC',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-56',
            rare        : 'R',
            name        : 'ミスティムーンブルートップス',
            imgUrl      : '/images/items/PT5-56.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-57',
            rare        : 'R',
            name        : 'ミスティムーンブルースカート',
            imgUrl      : '/images/items/PT5-57.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-58',
            rare        : 'R',
            name        : 'ミスティムーンブルーシューズ',
            imgUrl      : '/images/items/PT5-58.png',
            kind        : 'シューズ',
            color       : '銀',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-59',
            rare        : 'R',
            name        : 'ミスティムーンブルーヘアアクセ',
            imgUrl      : '/images/items/PT5-59.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-60',
            rare        : 'R',
            name        : 'フレアリボンかたみせさわやかワンピ',
            imgUrl      : '/images/items/PT5-60.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-61',
            rare        : 'R',
            name        : 'フレアリボンさわやかパンプス',
            imgUrl      : '/images/items/PT5-61.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-62',
            rare        : 'R',
            name        : 'フレアリボンさわやかぱっちんピン',
            imgUrl      : '/images/items/PT5-62.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            rare        : 'R',
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-63',
            rare        : 'R',
            name        : 'ティーパーティーオレンジトップス',
            imgUrl      : '/images/items/PT5-63.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-64',
            rare        : 'R',
            name        : 'ティーパーティーオレンジスカート',
            imgUrl      : '/images/items/PT5-64.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-65',
            rare        : 'R',
            name        : 'ティーパーティーオレンジシューズ',
            imgUrl      : '/images/items/PT5-65.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-66',
            rare        : 'R',
            name        : 'ティーパーティーオレンジヘアアクセ',
            imgUrl      : '/images/items/PT5-66.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'DW',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-67',
            rare        : 'R',
            name        : 'フレンチルックグリーンワンピ',
            imgUrl      : '/images/items/PT5-67.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 1000,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-68',
            rare        : 'R',
            name        : 'フレンチルックグリーンシューズ',
            imgUrl      : '/images/items/PT5-68.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-69',
            rare        : 'R',
            name        : 'フレンチルックグリーンヘアアクセ',
            imgUrl      : '/images/items/PT5-69.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            rare        : 'R',
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : 'PT05',
            id          : 'PT5-70',
            rare        : 'N',
            name        : 'ウィンターガーリーイエロートップス',
            imgUrl      : '/images/items/PT5-70.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-71',
            rare        : 'N',
            name        : 'ウィンターガーリーイエロースカート',
            imgUrl      : '/images/items/PT5-71.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-72',
            rare        : 'N',
            name        : 'ウィンターガーリーイエローシューズ',
            imgUrl      : '/images/items/PT5-72.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'CH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-73',
            rare        : 'N',
            name        : 'ウィンターガーリーイエローヘアアクセ',
            imgUrl      : '/images/items/PT5-73.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'CH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-74',
            rare        : 'N',
            name        : 'ミステリアスレディパープルトップス',
            imgUrl      : '/images/items/PT5-74.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-75',
            rare        : 'N',
            name        : 'ミステリアスレディパープルスカート',
            imgUrl      : '/images/items/PT5-75.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-76',
            rare        : 'N',
            name        : 'ミステリアスレディパープルシューズ',
            imgUrl      : '/images/items/PT5-76.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-77',
            rare        : 'N',
            name        : 'ミステリアスレディパープルヘアアクセ',
            imgUrl      : '/images/items/PT5-77.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-78',
            rare        : 'N',
            name        : 'ミリタリークールニット＆ショーパン',
            imgUrl      : '/images/items/PT5-78.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-79',
            rare        : 'N',
            name        : 'ミリタリーピンクブーツ',
            imgUrl      : '/images/items/PT5-79.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-80',
            rare        : 'N',
            name        : 'ミリタリーヘアアクセ',
            imgUrl      : '/images/items/PT5-80.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            rare        : 'N',
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-81',
            rare        : 'N',
            name        : 'ハートフルバレンタインブルートップス',
            imgUrl      : '/images/items/PT5-81.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-82',
            rare        : 'N',
            name        : 'ハートフルバレンタインブルースカート',
            imgUrl      : '/images/items/PT5-82.png',
            kind        : 'ボトムス',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 400,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-83',
            rare        : 'N',
            name        : 'ハートフルバレンタインブルーシューズ',
            imgUrl      : '/images/items/PT5-83.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'SA',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-84',
            rare        : 'N',
            name        : 'ハートフルバレンタインブルーヘアアクセ',
            imgUrl      : '/images/items/PT5-84.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SA',
            type        : 'CO',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PT05',
            id          : 'PT5-85',
            rare        : 'N',
            name        : 'バレンタインギフトミントオレンジトップス',
            imgUrl      : '/images/items/PT5-85.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 450,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-86',
            rare        : 'N',
            name        : 'バレンタインギフトミントオレンジスカート',
            imgUrl      : '/images/items/PT5-86.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'GY',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-87',
            rare        : 'N',
            name        : 'バレンタインギフトミントオレンジシューズ',
            imgUrl      : '/images/items/PT5-87.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PT05',
            id          : 'PT5-88',
            rare        : 'N',
            name        : 'バレンタインギフトミントオレンジヘアアクセ',
            imgUrl      : '/images/items/PT5-88.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : 'PT05',
            id          : 'PT5-44',
            rare        : 'SR',
            name        : 'おえかきセット',
            imgUrl      : '/images/items/PT5-44.png',
            kind        : 'パシャッとアイテム',
            color       : '茶',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プレゼントボックス
          // ================================================================================

          item({
            collection  : 'PBox',
            id          : 'PB-123',
            rare        : 'SR',
            name        : 'タッキー',
            imgUrl      : '/images/items/PB-123.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          externalItem(itemsVol02, 'PCH2-79' , { collection: 'PBox' }),
          externalItem(itemsVol05, 'PCH5-106', { collection: 'PBox' }),
          externalItem(itemsVol06, 'PCH6-119', { collection: 'PBox' }),


          item({
            collection  : 'PBox',
            id          : 'PT5-117',
            rare        : 'SR',
            name        : 'じゅんきんのプリたまGO',
            imgUrl      : '/images/items/PT5-117.png',
            kind        : 'パシャッとアイテム',
            color       : '金',
            brand       : 'LP',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PT5-118',
            rare        : 'SR',
            name        : 'でんせつのけん',
            imgUrl      : '/images/items/PT5-118.png',
            kind        : 'パシャッとアイテム',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PT5-119',
            rare        : 'SR',
            name        : 'げんせんグルメセレクション',
            imgUrl      : '/images/items/PT5-119.png',
            kind        : 'パシャッとアイテム',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PT5-120',
            rare        : 'SR',
            name        : 'オンラインパーティー',
            imgUrl      : '/images/items/PT5-120.png',
            kind        : 'パシャッとアイテム',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PBox',
            id          : 'PT5-121',
            rare        : 'SR',
            name        : 'ヤギ３びき',
            imgUrl      : '/images/items/PT5-121.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
            id          : 'PT5-122',
            rare        : 'PR',
            name        : 'じゅんきんルーム',
            imgUrl      : '/images/items/PT5-122.png',
            kind        : 'パシャッとアイテム',
            color       : '金',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PBox',
          }),
          item({
            collection  : 'PBox',
          }),


          // [NOTE] 3つのサンキュー！プリ☆チャンサンキューキャンペーン！
          // ================================================================================

          item({
            collection  : '999Campaign',
            id          : 'IR05-10',
            rare        : 'IR',
            name        : 'イルミナインスカイドレス',
            imgUrl      : '/images/items/IR05-10.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 1900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'IR05-11',
            rare        : 'IR',
            name        : 'イルミナインスカイシューズ',
            imgUrl      : '/images/items/IR05-11.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'IR05-12',
            rare        : 'IR',
            name        : 'イルミナインスカイヘアアクセ',
            imgUrl      : '/images/items/IR05-12.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            rare        : 'IR',
          }),


          item({
            collection  : '999Campaign',
            id          : 'IR05-13',
            rare        : 'IR',
            name        : 'イルミナインマーメイドドレス',
            imgUrl      : '/images/items/IR05-13.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 1900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'IR05-14',
            rare        : 'IR',
            name        : 'イルミナインマーメイドシューズ',
            imgUrl      : '/images/items/IR05-14.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'IR05-15',
            rare        : 'IR',
            name        : 'イルミナインマーメイドヘアアクセ',
            imgUrl      : '/images/items/IR05-15.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'CH',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            rare        : 'IR',
          }),


          item({
            collection  : '999Campaign',
            id          : 'IR05-16',
            rare        : 'IR',
            name        : 'イルミナインサーカスドレス',
            imgUrl      : '/images/items/IR05-16.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'FT',
            type        : 'NT',
            point       : 1900,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'IR05-17',
            rare        : 'IR',
            name        : 'イルミナインサーカスシューズ',
            imgUrl      : '/images/items/IR05-17.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'FT',
            type        : 'NT',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'IR05-18',
            rare        : 'IR',
            name        : 'イルミナインサーカスヘアアクセ',
            imgUrl      : '/images/items/IR05-18.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'FT',
            type        : 'NT',
            point       : 850,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            rare        : 'IR',
          }),


          item({
            collection  : '999Campaign',
            id          : 'PT5-113_',
            rare        : 'FR',
            name        : 'プリ☆ファンナイトピンクトップス',
            imgUrl      : '/images/items/PT5-113_.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 1100,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PT5-114',
            rare        : 'FR',
            name        : 'プリ☆ファンナイトピンクスカート',
            imgUrl      : '/images/items/PT5-114.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 1050,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PT5-115',
            rare        : 'FR',
            name        : 'プリ☆ファンナイトピンクシューズ',
            imgUrl      : '/images/items/PT5-115.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PT5-116',
            rare        : 'FR',
            name        : 'プリ☆ファンナイトピンクヘアアクセ',
            imgUrl      : '/images/items/PT5-116.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '999Campaign',
            id          : 'PB-99',
            rare        : 'SR',
            name        : 'バレンタインチョコミントトップス',
            imgUrl      : '/images/items/PB-99.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-100',
            rare        : 'SR',
            name        : 'バレンタインチョコミントスカート',
            imgUrl      : '/images/items/PB-100.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-101',
            rare        : 'SR',
            name        : 'バレンタインチョコミントシューズ',
            imgUrl      : '/images/items/PB-101.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-102',
            rare        : 'SR',
            name        : 'バレンタインチョコミントヘアアクセ',
            imgUrl      : '/images/items/PB-102.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '999Campaign',
            id          : 'PB-103',
            rare        : 'SR',
            name        : 'ムーンライトレッドトップス',
            imgUrl      : '/images/items/PB-103.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-104',
            rare        : 'SR',
            name        : 'ムーンライトレッドパンツ',
            imgUrl      : '/images/items/PB-104.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-105',
            rare        : 'SR',
            name        : 'ムーンライトレッドシューズ',
            imgUrl      : '/images/items/PB-105.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-106',
            rare        : 'SR',
            name        : 'ムーンライトレッドヘアアクセ',
            imgUrl      : '/images/items/PB-106.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '999Campaign',
            id          : 'PB-107',
            rare        : 'SR',
            name        : 'ししゅういりロングニットワンピ',
            imgUrl      : '/images/items/PB-107.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-108',
            rare        : 'SR',
            name        : 'カフェモカフラワーブーツ',
            imgUrl      : '/images/items/PB-108.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '999Campaign',
            id          : 'PB-109',
            rare        : 'SR',
            name        : 'オトナめジャンパースカート',
            imgUrl      : '/images/items/PB-109.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'SE',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-110',
            rare        : 'SR',
            name        : 'プリズムスクールローファー',
            imgUrl      : '/images/items/PB-110.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : '',
            type        : 'SE',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '999Campaign',
            id          : 'PB-111',
            rare        : 'SR',
            name        : 'ホワイトデーハートトップス',
            imgUrl      : '/images/items/PB-111.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-112',
            rare        : 'SR',
            name        : 'ホワイトデーハートスカート',
            imgUrl      : '/images/items/PB-112.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-113',
            rare        : 'SR',
            name        : 'ホワイトデーハートシューズ',
            imgUrl      : '/images/items/PB-113.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-114',
            rare        : 'SR',
            name        : 'ホワイトデーハートヘアアクセ',
            imgUrl      : '/images/items/PB-114.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          externalItem(itemsPromo2018, 'SP-005', {
            collection  : '999Campaign',
            id          : 'PB-115',
            imgUrl      : '/images/items/PB-115.png',
            point       : 750,
          }),
          externalItem(itemsPromo2018, 'SP-006', {
            collection  : '999Campaign',
            id          : 'PB-116',
            imgUrl      : '/images/items/PB-116.png',
            point       : 700,
          }),
          externalItem(itemsPromo2018, 'SP-007', {
            collection  : '999Campaign',
            id          : 'PB-117',
            imgUrl      : '/images/items/PB-117.png',
            point       : 650,
          }),
          externalItem(itemsPromo2018, 'SP-008', {
            collection  : '999Campaign',
            id          : 'PB-118',
            imgUrl      : '/images/items/PB-118.png',
            point       : 650,
          }),


          item({
            collection  : '999Campaign',
            id          : 'PB-119',
            rare        : 'SR',
            name        : 'ウエスタンファーベスト',
            imgUrl      : '/images/items/PB-119.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'NT',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-120',
            rare        : 'SR',
            name        : 'フリルデニムショーパン',
            imgUrl      : '/images/items/PB-120.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'NT',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-121',
            rare        : 'SR',
            name        : 'あみあげハードブーツ',
            imgUrl      : '/images/items/PB-121.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : '',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '999Campaign',
            id          : 'PB-122',
            rare        : 'SR',
            name        : 'フォーチュンパーティースターヘアアクセ',
            imgUrl      : '/images/items/PB-122.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),



          // [NOTE] ラブパトリーナチャンネル
          // ================================================================================

          item({
            collection  : 'LovePato',
            id          : 'PT5-108',
            rare        : 'SR',
            name        : 'ラブパトパープルサライワンピ',
            imgUrl      : '/images/items/PT5-108.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'LovePato',
            id          : 'PT5-109',
            rare        : 'SR',
            name        : 'ラブパトパープルサライシューズ',
            imgUrl      : '/images/items/PT5-109.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'LovePato',
            id          : 'PT5-110',
            rare        : 'SR',
            name        : 'ラブパトパープルサライヘアアクセ',
            imgUrl      : '/images/items/PT5-110.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'LovePato',
            rare        : 'SR',
          }),


          item({
            collection  : 'LovePato',
            id          : 'PT5-111',
            rare        : 'SR',
            name        : 'ラブパトブルーコハナワンピ',
            imgUrl      : '/images/items/PT5-111.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'LovePato',
            id          : 'PT5-112',
            rare        : 'SR',
            name        : 'ラブパトブルーコハナシューズ',
            imgUrl      : '/images/items/PT5-112.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'LovePato',
            id          : 'PT5-113',
            rare        : 'SR',
            name        : 'ラブパトブルーコハナヘアアクセ',
            imgUrl      : '/images/items/PT5-113.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'LovePato',
            rare        : 'SR',
          }),


          // [NOTE] アライブチャンネル
          // ================================================================================

          item({
            collection  : 'Alive',
            id          : 'PT5-97',
            rare        : 'SR',
            name        : 'ポルカフローラレッドワンピ',
            imgUrl      : '/images/items/PT5-97.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'FT',
            type        : 'NT',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Alive',
            id          : 'PT5-98',
            rare        : 'SR',
            name        : 'ポルカフローラレッドシューズ',
            imgUrl      : '/images/items/PT5-98.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'FT',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Alive',
            id          : 'PT5-99',
            rare        : 'SR',
            name        : 'ポルカフローラレッドヘアアクセ',
            imgUrl      : '/images/items/PT5-99.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'FT',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Alive',
            rare        : 'SR'
          }),


          item({
            collection  : 'Alive',
            id          : 'PT5-100',
            rare        : 'SR',
            name        : 'レディールージュナイトトップス',
            imgUrl      : '/images/items/PT5-100.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'MM',
            type        : 'SE',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Alive',
            id          : 'PT5-101',
            rare        : 'SR',
            name        : 'レディールージュナイトスカート',
            imgUrl      : '/images/items/PT5-101.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'MM',
            type        : 'SE',
            point       : 750,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Alive',
            id          : 'PT5-102',
            rare        : 'SR',
            name        : 'レディールージュナイトシューズ',
            imgUrl      : '/images/items/PT5-102.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'MM',
            type        : 'SE',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Alive',
            id          : 'PT5-103',
            rare        : 'SR',
            name        : 'レディールージュナイトヘアアクセ',
            imgUrl      : '/images/items/PT5-103.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'MM',
            type        : 'SE',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] サンリオキャラクターズチャンネル
          // ================================================================================

          item({
            collection  : 'Sanrio',
            id          : 'PT5-104',
            rare        : 'SR',
            name        : 'ポムポムプリンおでかけワンピ',
            imgUrl      : '/images/items/PT5-104.png',
            kind        : 'ワンピース',
            color       : '茶',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            id          : 'PT5-105',
            rare        : 'SR',
            name        : 'ポムポムプリンおでかけシューズ',
            imgUrl      : '/images/items/PT5-105.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            id          : 'PT5-106',
            rare        : 'SR',
            name        : 'ポムポムプリンおでかけヘアアクセ',
            imgUrl      : '/images/items/PT5-106.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Sanrio',
            id          : 'PT5-107',
            rare        : 'SR',
            name        : 'ポムポムプリンパネル',
            imgUrl      : '/images/items/PT5-107.png',
            kind        : 'パシャッとアイテム',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ふっこく！サンリオキャラクターズチャンネル
          // ================================================================================

          externalItem(itemsPriTama03, 'PT3-101', { collection: 'ReappearSanrio' }),
          externalItem(itemsPriTama03, 'PT3-102', { collection: 'ReappearSanrio' }),
          externalItem(itemsPriTama03, 'PT3-103', { collection: 'ReappearSanrio' }),
          item({ collection: 'ReappearSanrio' }),

          externalItem(itemsPriTama03, 'PT3-104', { collection: 'ReappearSanrio' }),
          externalItem(itemsPriTama03, 'PT3-105', { collection: 'ReappearSanrio' }),
          externalItem(itemsPriTama03, 'PT3-106', { collection: 'ReappearSanrio' }),
          externalItem(itemsPriTama03, 'PT3-107', { collection: 'ReappearSanrio' }),

          externalItem(itemsPriTama04, 'PT4-102', { collection: 'ReappearSanrio' }),
          externalItem(itemsPriTama04, 'PT4-103', { collection: 'ReappearSanrio' }),
          externalItem(itemsPriTama04, 'PT4-104', { collection: 'ReappearSanrio' }),
          externalItem(itemsPriTama04, 'PT4-105', { collection: 'ReappearSanrio' }),

          externalItem(itemsPriTama04, 'PT4-99' , { collection: 'ReappearSanrio' }),
          externalItem(itemsPriTama04, 'PT4-100', { collection: 'ReappearSanrio' }),
          externalItem(itemsPriTama04, 'PT4-101', { collection: 'ReappearSanrio' }),
          item({ collection: 'ReappearSanrio' }),


          // [NOTE] ふっこく！すみっコぐらしチャンネル１
          // ================================================================================

          externalItem(itemsJewel05, 'J5-58', { collection: 'Sumikko' }),
          externalItem(itemsJewel05, 'J5-59', { collection: 'Sumikko' }),
          externalItem(itemsJewel05, 'J5-60', { collection: 'Sumikko' }),
          item({ collection: 'Sumikko' }),

          externalItem(itemsVol04, 'PCH4-83', { collection: 'Sumikko' }),
          externalItem(itemsVol04, 'PCH4-84', { collection: 'Sumikko' }),
          externalItem(itemsVol04, 'PCH4-85', { collection: 'Sumikko' }),
          item({ collection: 'Sumikko' }),

          externalItem(itemsVol04, 'PCH4-86', { collection: 'Sumikko' }),
          externalItem(itemsVol04, 'PCH4-87', { collection: 'Sumikko' }),
          externalItem(itemsVol04, 'PCH4-88', { collection: 'Sumikko' }),
          item({ collection: 'Sumikko' }),

          externalItem(itemsJewel03, 'J3-111' , { collection: 'Sumikko' }),
          externalItem(itemsJewel03, 'J3-112' , { collection: 'Sumikko' }),
          externalItem(itemsJewel03, 'J3-113' , { collection: 'Sumikko' }),
          item({ collection: 'Sumikko' }),

          externalItem(itemsJewel03, 'J3-114' , { collection: 'Sumikko' }),
          externalItem(itemsVol03, 'PCH3-78', { collection: 'Sumikko' }),
          item({ collection: 'Sumikko' }),
          item({ collection: 'Sumikko' }),


          // [NOTE] ふっこく！すみっコぐらし＆リラックマチャンネル１
          // ================================================================================

          externalItem(itemsVol04, 'PCH4-89', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol04, 'PCH4-90', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol04, 'PCH4-91', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol04, 'PCH4-92', { collection: 'SumikkoRelakuma' }),

          externalItem(itemsVol04, 'PCH4-93', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol04, 'PCH4-94', { collection: 'SumikkoRelakuma' }),
          item({ collection: 'SumikkoRelakuma' }),
          item({ collection: 'SumikkoRelakuma' }),

          externalItem(itemsPriTama02, 'PT2-111', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsPriTama02, 'PT2-112', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsPriTama02, 'PT2-113', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol04, 'PCH4-82', { collection: 'SumikkoRelakuma' }),

          externalItem(itemsPriTama02, 'PT2-114', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsPriTama02, 'PT2-115', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsPriTama02, 'PT2-116', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsPriTama02, 'PT2-117', { collection: 'SumikkoRelakuma' }),

          externalItem(itemsVol06, 'PCH6-80', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol06, 'PCH6-81', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol06, 'PCH6-82', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol06, 'PCH6-83', { collection: 'SumikkoRelakuma' }),


          // [NOTE] ハッピーレア大量発生チャンネル
          // ================================================================================

          externalItem(itemsJewel03, 'J3-01', { collection: 'MassiveHR' }),
          externalItem(itemsJewel03, 'J3-02', { collection: 'MassiveHR' }),
          externalItem(itemsJewel03, 'J3-03', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalItem(itemsJewel03, 'J3-73', { collection: 'MassiveHR' }),
          externalItem(itemsJewel03, 'J3-74', { collection: 'MassiveHR' }),
          externalItem(itemsJewel03, 'J3-75', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalItem(itemsJewel03, 'J3-04', { collection: 'MassiveHR' }),
          externalItem(itemsJewel03, 'J3-05', { collection: 'MassiveHR' }),
          externalItem(itemsJewel03, 'J3-06', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalItem(itemsJewel03, 'J3-76', { collection: 'MassiveHR' }),
          externalItem(itemsJewel03, 'J3-77', { collection: 'MassiveHR' }),
          externalItem(itemsJewel03, 'J3-78', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalItem(itemsJewel06, 'J6-01', { collection: 'MassiveHR' }),
          externalItem(itemsJewel06, 'J6-02', { collection: 'MassiveHR' }),
          externalItem(itemsJewel06, 'J6-03', { collection: 'MassiveHR' }),
          externalItem(itemsJewel06, 'J6-04', { collection: 'MassiveHR' }),

          externalItem(itemsJewel06, 'J6-75', { collection: 'MassiveHR' }),
          externalItem(itemsJewel06, 'J6-76', { collection: 'MassiveHR' }),
          externalItem(itemsJewel06, 'J6-77', { collection: 'MassiveHR' }),
          externalItem(itemsJewel06, 'J6-78', { collection: 'MassiveHR' }),

          externalItem(itemsJewel06, 'J6-05', { collection: 'MassiveHR' }),
          externalItem(itemsJewel06, 'J6-06', { collection: 'MassiveHR' }),
          externalItem(itemsJewel06, 'J6-07', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalItem(itemsJewel06, 'J6-08', { collection: 'MassiveHR' }),
          externalItem(itemsJewel06, 'J6-09', { collection: 'MassiveHR' }),
          externalItem(itemsJewel06, 'J6-10', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalItem(itemsJewel06, 'J6-79', { collection: 'MassiveHR' }),
          externalItem(itemsJewel06, 'J6-80', { collection: 'MassiveHR' }),
          externalItem(itemsJewel06, 'J6-81', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),

          externalItem(itemsJewel06, 'J6-82', { collection: 'MassiveHR' }),
          externalItem(itemsJewel06, 'J6-83', { collection: 'MassiveHR' }),
          externalItem(itemsJewel06, 'J6-84', { collection: 'MassiveHR' }),
          item({ rare: 'HR', collection: 'MassiveHR' }),


          // [NOTE] プリ☆チャンファンタジーふっこくチャンネル1
          // ================================================================================

          externalItem(itemsPriTama01, 'PT1-01', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama01, 'PT1-02', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama01, 'PT1-03', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama01, 'PT1-04', { collection: 'ReappearFR' }),

          externalItem(itemsPriTama01, 'PT1-05', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama01, 'PT1-06', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama01, 'PT1-07', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama01, 'PT1-08', { collection: 'ReappearFR' }),

          externalItem(itemsPriTama02, 'PT2-01', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama02, 'PT2-02', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama02, 'PT2-03', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama02, 'PT2-04', { collection: 'ReappearFR' }),

          externalItem(itemsPriTama03, 'PT3-01', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama03, 'PT3-02', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama03, 'PT3-03', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama03, 'PT3-04', { collection: 'ReappearFR' }),

          externalItem(itemsPriTama03, 'PT3-05', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama03, 'PT3-06', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama03, 'PT3-07', { collection: 'ReappearFR' }),
          externalItem(itemsPriTama03, 'PT3-08', { collection: 'ReappearFR' }),


          // [NOTE] ニコチケ PR
          // ================================================================================

          item({
            collection  : 'Nico',
            id          : 'NC-PT5-01',
            rare        : 'PR',
            name        : 'ミッドナイトジュエリーレッドトップス',
            imgUrl      : '/images/items/NC-PT5-01.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'MM',
            type        : 'SE',
            point       : 900,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-02',
            rare        : 'PR',
            name        : 'ミッドナイトジュエリーレッドスカート',
            imgUrl      : '/images/items/NC-PT5-02.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'MM',
            type        : 'SE',
            point       : 800,
            aggregation : 'NC-PT5-01',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-03',
            rare        : 'PR',
            name        : 'ミッドナイトジュエリーレッドシューズ',
            imgUrl      : '/images/items/NC-PT5-03.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'MM',
            type        : 'SE',
            point       : 850,
            aggregation : 'NC-PT5-01',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-04',
            rare        : 'PR',
            name        : 'ミッドナイトジュエリーレッドヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-04.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'MM',
            type        : 'SE',
            point       : 800,
            aggregation : 'NC-PT5-01',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-05',
            rare        : 'PR',
            name        : 'マスコットルルナピンクトップス',
            imgUrl      : '/images/items/NC-PT5-05.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'LP',
            type        : 'SE',
            point       : 900,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-06',
            rare        : 'PR',
            name        : 'マスコットルルナピンクスカート',
            imgUrl      : '/images/items/NC-PT5-06.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'LP',
            type        : 'SE',
            point       : 850,
            aggregation : 'NC-PT5-05',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-07',
            rare        : 'PR',
            name        : 'マスコットルルナピンクシューズ',
            imgUrl      : '/images/items/NC-PT5-07.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'LP',
            type        : 'SE',
            point       : 800,
            aggregation : 'NC-PT5-05',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-08',
            rare        : 'PR',
            name        : 'マスコットルルナピンクヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-08.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'LP',
            type        : 'SE',
            point       : 800,
            aggregation : 'NC-PT5-05',
          }),


          // [NOTE] ニコチケ SR
          // ================================================================================

          item({
            collection  : 'Nico',
            id          : 'NC-PT5-09',
            rare        : 'SR',
            name        : 'テディベアラブリーグリーントップス',
            imgUrl      : '/images/items/NC-PT5-09.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-10',
            rare        : 'SR',
            name        : 'テディベアラブリーグリーンスカート',
            imgUrl      : '/images/items/NC-PT5-10.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            aggregation : 'NC-PT5-09',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-11',
            rare        : 'SR',
            name        : 'テディベアラブリーグリーンシューズ',
            imgUrl      : '/images/items/NC-PT5-11.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            aggregation : 'NC-PT5-09',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-12',
            rare        : 'SR',
            name        : 'テディベアラブリーグリーンヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-12.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 650,
            aggregation : 'NC-PT5-09',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-13',
            rare        : 'SR',
            name        : 'テディベアポップグリーントップス',
            imgUrl      : '/images/items/NC-PT5-13.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-14',
            rare        : 'SR',
            name        : 'テディベアポップグリーンパンツ',
            imgUrl      : '/images/items/NC-PT5-14.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            aggregation : 'NC-PT5-13',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-15',
            rare        : 'SR',
            name        : 'テディベアポップグリーンシューズ',
            imgUrl      : '/images/items/NC-PT5-15.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-PT5-13',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-16',
            rare        : 'SR',
            name        : 'テディベアポップグリーンヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-16.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            aggregation : 'NC-PT5-13',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-17',
            rare        : 'SR',
            name        : 'ビビッドマーチングブルートップス',
            imgUrl      : '/images/items/NC-PT5-17.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-18',
            rare        : 'SR',
            name        : 'ビビッドマーチングブルースカート',
            imgUrl      : '/images/items/NC-PT5-18.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            aggregation : 'NC-PT5-17',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-19',
            rare        : 'SR',
            name        : 'ビビッドマーチングブルーシューズ',
            imgUrl      : '/images/items/NC-PT5-19.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT5-17',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-20',
            rare        : 'SR',
            name        : 'ビビッドマーチングブルーヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-20.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT5-17',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-21',
            rare        : 'SR',
            name        : 'ビビッドマーチングオレンジトップス',
            imgUrl      : '/images/items/NC-PT5-21.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-22',
            rare        : 'SR',
            name        : 'ビビッドマーチングオレンジスカート',
            imgUrl      : '/images/items/NC-PT5-22.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT5-21',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-23',
            rare        : 'SR',
            name        : 'ビビッドマーチングオレンジシューズ',
            imgUrl      : '/images/items/NC-PT5-23.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            aggregation : 'NC-PT5-21',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-24',
            rare        : 'SR',
            name        : 'ビビッドマーチングオレンジヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-24.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            aggregation : 'NC-PT5-21',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-25',
            rare        : 'SR',
            name        : 'あさのアナザーワンピ',
            imgUrl      : '/images/items/NC-PT5-25.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-26',
            rare        : 'SR',
            name        : 'あさのアナザーシューズ',
            imgUrl      : '/images/items/NC-PT5-26.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 650,
            aggregation : 'NC-PT5-25',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-27',
            rare        : 'SR',
            name        : 'あさのアナザーヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-27.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 650,
            aggregation : 'NC-PT5-25',
          }),
          item({
            collection  : 'Nico',
            rare        : 'SR',
          }),


          // [NOTE] ニコチケ R
          // ================================================================================

          item({
            collection  : 'Nico',
            id          : 'NC-PT5-28',
            rare        : 'R',
            name        : 'スケーターダンストップス',
            imgUrl      : '/images/items/NC-PT5-28.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DS',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-29',
            rare        : 'R',
            name        : 'スケーターダンスパンツ',
            imgUrl      : '/images/items/NC-PT5-29.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'DS',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT5-28',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-30',
            rare        : 'R',
            name        : 'スケーターダンスシューズ',
            imgUrl      : '/images/items/NC-PT5-30.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT5-28',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-31',
            rare        : 'R',
            name        : 'スケーターダンスヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-31.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT5-28',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-32',
            rare        : 'R',
            name        : 'スケーターダンスライムトップス',
            imgUrl      : '/images/items/NC-PT5-32.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-33',
            rare        : 'R',
            name        : 'スケーターダンスライムパンツ',
            imgUrl      : '/images/items/NC-PT5-33.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'DS',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT5-32',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-34',
            rare        : 'R',
            name        : 'スケーターダンスライムシューズ',
            imgUrl      : '/images/items/NC-PT5-34.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT5-32',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-35',
            rare        : 'R',
            name        : 'スケーターダンスライムヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-35.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT5-32',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-36',
            rare        : 'R',
            name        : 'スケーターダンスシトラストップス',
            imgUrl      : '/images/items/NC-PT5-36.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'DS',
            type        : 'CO',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-37',
            rare        : 'R',
            name        : 'スケーターダンスシトラスパンツ',
            imgUrl      : '/images/items/NC-PT5-37.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DS',
            type        : 'CO',
            point       : 550,
            aggregation : 'NC-PT5-36',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-38',
            rare        : 'R',
            name        : 'スケーターダンスシトラスシューズ',
            imgUrl      : '/images/items/NC-PT5-38.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT5-36',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-39',
            rare        : 'R',
            name        : 'スケーターダンスシトラスヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-39.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DS',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT5-36',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-40',
            rare        : 'R',
            name        : 'アイドルスターグループKワンピ',
            imgUrl      : '/images/items/NC-PT5-40.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 1000,
            numOwned    : { nico: 3 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-41',
            rare        : 'R',
            name        : 'アイドルスターグループKシューズ',
            imgUrl      : '/images/items/NC-PT5-41.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT5-40',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-42',
            rare        : 'R',
            name        : 'アイドルスターグループKヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-42.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT5-40',
          }),
          item({
            collection  : 'Nico',
            rare        : 'R',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-43',
            rare        : 'R',
            name        : 'アイドルスターグループMワンピ',
            imgUrl      : '/images/items/NC-PT5-43.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 1000,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-44',
            rare        : 'R',
            name        : 'アイドルスターグル―プMシューズ',
            imgUrl      : '/images/items/NC-PT5-44.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT5-43',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-45',
            rare        : 'R',
            name        : 'アイドルスターグループMヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-45.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT5-43',
          }),
          item({
            collection  : 'Nico',
            rare        : 'R',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-46',
            rare        : 'R',
            name        : 'アイドルスターグループRワンピ',
            imgUrl      : '/images/items/NC-PT5-46.png',
            kind        : 'ワンピース',
            color       : '茶',
            brand       : 'RB',
            type        : 'CO',
            point       : 1000,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-47',
            rare        : 'R',
            name        : 'アイドルスターグループRシューズ',
            imgUrl      : '/images/items/NC-PT5-47.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT5-46',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-48',
            rare        : 'R',
            name        : 'アイドルスターグループRヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-48.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'RB',
            type        : 'CO',
            point       : 500,
            aggregation : 'NC-PT5-46',
          }),
          item({
            collection  : 'Nico',
            rare        : 'R',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-49',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストオレンジトップス',
            imgUrl      : '/images/items/NC-PT5-49.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'LP',
            type        : 'NT',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-50',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストオレンジスカート',
            imgUrl      : '/images/items/NC-PT5-50.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'LP',
            type        : 'NT',
            point       : 550,
            aggregation : 'NC-PT5-49',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-51',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストオレンジシューズ',
            imgUrl      : '/images/items/NC-PT5-51.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'LP',
            type        : 'NT',
            point       : 500,
            aggregation : 'NC-PT5-49',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-52',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストオレンジヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-52.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'LP',
            type        : 'NT',
            point       : 500,
            aggregation : 'NC-PT5-49',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-53',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストネイビートップス',
            imgUrl      : '/images/items/NC-PT5-53.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-54',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストネイビースカート',
            imgUrl      : '/images/items/NC-PT5-54.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 550,
            aggregation : 'NC-PT5-53',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-55',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストネイビーシューズ',
            imgUrl      : '/images/items/NC-PT5-55.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 500,
            aggregation : 'NC-PT5-53',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-56',
            rare        : 'R',
            name        : 'プリ☆チャンランドキャストネイビーヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-56.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 500,
            aggregation : 'NC-PT5-53',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-57',
            rare        : 'R',
            name        : 'マスコットパーティーセレブトップス',
            imgUrl      : '/images/items/NC-PT5-57.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-58',
            rare        : 'R',
            name        : 'マスコットパーティーセレブスカート',
            imgUrl      : '/images/items/NC-PT5-58.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 550,
            aggregation : 'NC-PT5-57',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-59',
            rare        : 'R',
            name        : 'マスコットパーティーセレブシューズ',
            imgUrl      : '/images/items/NC-PT5-59.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'LP',
            type        : 'SE',
            point       : 500,
            aggregation : 'NC-PT5-57',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-60',
            rare        : 'R',
            name        : 'マスコットパーティーセレブヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-60.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 500,
            aggregation : 'NC-PT5-57',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-61',
            rare        : 'R',
            name        : 'レインボーライブフェミニントップス',
            imgUrl      : '/images/items/NC-PT5-61.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'DC',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-62',
            rare        : 'R',
            name        : 'レインボーライブフェミニンスカート',
            imgUrl      : '/images/items/NC-PT5-62.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'DC',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT5-61',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-63',
            rare        : 'R',
            name        : 'レインボーライブフェミニンシューズ',
            imgUrl      : '/images/items/NC-PT5-63.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DC',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT5-61',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-64',
            rare        : 'R',
            name        : 'レインボーライブフェミニンヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-64.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DC',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT5-61',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-65',
            rare        : 'R',
            name        : 'レインボーライブエスニックトップス',
            imgUrl      : '/images/items/NC-PT5-65.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'DC',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-66',
            rare        : 'R',
            name        : 'レインボーライブエスニックスカート',
            imgUrl      : '/images/items/NC-PT5-66.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'DC',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT5-65',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-67',
            rare        : 'R',
            name        : 'レインボーライブエスニックシューズ',
            imgUrl      : '/images/items/NC-PT5-67.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DC',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT5-65',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-68',
            rare        : 'R',
            name        : 'レインボーライブエスニックヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-68.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DC',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT5-65',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-69',
            rare        : 'R',
            name        : 'ショウゴスタースタジャン',
            imgUrl      : '/images/items/NC-PT5-69.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-70',
            rare        : 'R',
            name        : 'ショウゴスタースカート',
            imgUrl      : '/images/items/NC-PT5-70.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'LO',
            point       : 550,
            aggregation : 'NC-PT5-69',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-71',
            rare        : 'R',
            name        : 'ショウゴスターシューズ',
            imgUrl      : '/images/items/NC-PT5-71.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT5-69',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-72',
            rare        : 'R',
            name        : 'ショウゴスターヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-72.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'LO',
            point       : 500,
            aggregation : 'NC-PT5-69',
          }),


          item({
            collection  : 'Nico',
            id          : 'NC-PT5-73',
            rare        : 'R',
            name        : 'ブラックスワンイブトップス',
            imgUrl      : '/images/items/NC-PT5-73.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'MM',
            type        : 'SE',
            point       : 600,
            numOwned    : { nico: 4 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-74',
            rare        : 'R',
            name        : 'ブラックスワンイブスカート',
            imgUrl      : '/images/items/NC-PT5-74.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'MM',
            type        : 'SE',
            point       : 550,
            aggregation : 'NC-PT5-73',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-75',
            rare        : 'R',
            name        : 'ブラックスワンイブシューズ',
            imgUrl      : '/images/items/NC-PT5-75.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'MM',
            type        : 'SE',
            point       : 500,
            aggregation : 'NC-PT5-73',
          }),
          item({
            collection  : 'Nico',
            id          : 'NC-PT5-76',
            rare        : 'R',
            name        : 'ブラックスワンイブヘアアクセ',
            imgUrl      : '/images/items/NC-PT5-76.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'MM',
            type        : 'SE',
            point       : 500,
            aggregation : 'NC-PT5-73',
          }),


        ]
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsHR () {
        return _.where(this.itemsFiltered, { rare: 'HR' })
      },

      itemsIR () {
        return _.where(this.itemsMaJor, { rare: 'IR' })
      },

      itemsWR () {
        return _.where(this.itemsMaJor, { rare: 'WR' })
      },

      itemsER () {
        return _.where(this.itemsMaJor, { rare: 'ER' })
      },

      itemsFR () {
        return _.where(this.itemsMaJor, { rare: 'FR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, { rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, { rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, { rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, { rare: 'N' })
      },

      itemsNico () {
        return _.where(this.itemsFiltered, { collection: 'Nico' })
      },

      itemsNicoPR () {
        return _.where(this.itemsNico, { rare: 'PR' })
      },

      itemsNicoSR () {
        return _.where(this.itemsNico, { rare: 'SR' })
      },

      itemsNicoR () {
        return _.where(this.itemsNico, { rare: 'R' })
      },

      itemsNicoN () {
        return _.where(this.itemsNico, { rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => this.major.includes(item.collection) )
      },

      itemsPBox () {
        return _.where(this.itemsFiltered, { collection: 'PBox' })
      },

      itemsMolly () {
        return _.where(this.itemsFiltered, { collection: 'Molly' })
      },

      itemsLovePato () {
        return _.where(this.itemsFiltered, { collection: 'LovePato' })
      },

      itemsAlive () {
        return _.where(this.itemsFiltered, { collection: 'Alive' })
      },

      itemsSanrio () {
        return _.where(this.itemsFiltered, { collection: 'Sanrio' })
      },

      itemsReappearSanrio () {
        return _.where(this.itemsFiltered, { collection: 'ReappearSanrio' })
      },

      itemsSumikko () {
        return _.where(this.itemsFiltered, { collection: 'Sumikko' })
      },

      itemsSumikkoRelakuma () {
        return _.where(this.itemsFiltered, { collection: 'SumikkoRelakuma' })
      },

      itemsReappearFR () {
        return _.where(this.itemsFiltered, { collection: 'ReappearFR' })
      },

      items999CampaignIR () {
        return _.where(this.itemsFiltered, { collection: '999Campaign', rare: 'IR' })
      },

      items999CampaignFR () {
        return _.where(this.itemsFiltered, { collection: '999Campaign', rare: 'FR' })
      },

      items999CampaignSR () {
        return _.where(this.itemsFiltered, { collection: '999Campaign', rare: 'SR' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="✨ IR ✨" color="#edd50f" :items="itemsIR" />
      <ItemList title="🥚 ER 🥚" color="#44cd1f" :items="itemsER" />
    </template>

    <template #col2>
      <ItemList title="⭐️ WR ⭐️" color="#ffca59" :items="itemsWR" />
      <ItemList title="👑 FR 👑" color="#ff5d91" :items="itemsFR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col3>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="モーリー限定 SR ★★" color="#55b272" :items="itemsMolly" />
    </template>

    <template #col4>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>

    <template #col5>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
    </template>

    <template #col6>
      <ItemList title="✨ サンキューキャンペーン IR ✨" color="#edd50f" :items="items999CampaignIR" />
      <ItemList title="👑 サンキューキャンペーン FR 👑" color="#ff5d91" :items="items999CampaignFR" />
      <ItemList title="サンキューキャンペーン SR ★★" color="#00c7da" :items="items999CampaignSR" />
    </template>

    <template #col7>
      <ItemList title="ラブパトリーナチャンネル" color="#a1c0fa" :items="itemsLovePato" />
      <ItemList title="アライブチャンネル" color="#a1c0fa" :items="itemsAlive" />
      <ItemList title="サンリオキャラクターズ|チャンネル" color="#a1c0fa" :items="itemsSanrio" />
      <ItemList title="ふっこく！サンリオキャラクターズチャンネル" color="#a1c0fa" :items="itemsReappearSanrio" />
    </template>

    <template #col8>
      <ItemList title="ふっこく！すみっコぐらし|チャンネル１" color="#a1c0fa" :items="itemsSumikko" />
      <ItemList title="ふっこく！すみっコぐらし|＆リラックマチャンネル" color="#a1c0fa" :items="itemsSumikkoRelakuma" />
    </template>

    <template #col9>
      <ItemList title="ハッピーレア大量発生|チャンネル" color="#ff5d91" :items="itemsHR" />
    </template>

    <template #col10>
      <ItemList title="プリ☆チャンファンタジー|ふっこくチャンネル1" color="#ff5d91" :items="itemsReappearFR" />
    </template>

    <template #col11>
      <ItemList title="ニコチケ PR ★★★" color="#ffa1bc" :items="itemsNicoPR" />
      <ItemList title="ニコチケ SR ★★" color="#00c7da" :items="itemsNicoSR" />
    </template>

    <template #col12>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | first(7 * 4)" />
    </template>

    <template #col13>
      <ItemList title="ニコチケ R ★" color="#feab0d" :items="itemsNicoR | rest(7 * 4)" :isOrphan="true" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: $size-unit * 221;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }

  // コレクショングループ間の間隔 (IR)
  .Page ::v-deep .Page__col:nth-child(1) .ItemList:nth-child(1) {
    .Item:nth-child(13),
    .Item:nth-child(14),
    .Item:nth-child(15),
    .Item:nth-child(16) {
      margin-top: $size-unit * 8;
    }
  }

</style>
